import React from 'react';
import astrid from 'assets/images/idleCafe/astrid.png';
import logomarkAndText from 'assets/images/idleCafe/logomarkandtext.png';
import { AppStoreButtons } from 'molecules';
import { Text } from 'atoms';
import { color, size, tracking } from 'designs';
import {
  IDLE_CAFE_ANDROID_URL,
  IDLE_CAFE_FEATURES,
  IDLE_CAFE_HEADLINE,
  IDLE_CAFE_IOS_URL,
  IDLE_CAFE_SUBTITLE,
  IDLE_CAFE_TAGLINE,
} from 'data';

const IdleCafeHeroSection: React.FC = () => {
  return (
    <>
      <section className="cafe-hero">
        <div className="cafe-hero-mark">
          <img
            src={logomarkAndText}
            alt="Moss &amp; Moon"
            className="cafe-hero-mark-img"
          />
        </div>

        <div className="cafe-hero-copy">
          <Text
            as="h1"
            size={size.display}
            tracking={tracking.tight}
            className="cafe-display"
          >
            Idle Café
          </Text>
          <Text as="p" color={color.idleCafeLightOlive} className="cafe-subtitle">
            {IDLE_CAFE_SUBTITLE}
          </Text>
          <Text as="p" size={size.large} className="cafe-headline">
            {IDLE_CAFE_HEADLINE}
          </Text>
          <Text as="p" color={color.idleCafeParchment} className="cafe-tagline">
            {IDLE_CAFE_TAGLINE}
          </Text>
          <AppStoreButtons
            iosUrl={IDLE_CAFE_IOS_URL}
            androidUrl={IDLE_CAFE_ANDROID_URL}
          />
        </div>
      </section>

      <section className="cafe-about">
        <div className="cafe-about-portrait">
          <img src={astrid} alt="" className="cafe-about-portrait-img" />
        </div>

        <div className="cafe-about-features">
          {IDLE_CAFE_FEATURES.map((feature) => (
            <div className="cafe-feature" key={feature.title}>
              <Text
                as="h2"
                size={size.small}
                tracking={tracking.tight}
                className="cafe-feature-title"
              >
                {feature.title}
              </Text>
              <Text
                as="p"
                color={color.idleCafeParchment}
                className="cafe-feature-body"
              >
                {feature.body}
              </Text>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default IdleCafeHeroSection;
